import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  AskLioQuery,
  AskLioRecommnededQuestion,
} from '../../types/ask-lio/askLioTypes';

interface AskLioState {
  isChatPanelVisible: boolean;
  askLioQuery: AskLioQuery[];
  suggestedQuetions: AskLioRecommnededQuestion[];
  responseOnProcess: boolean;
  hasNotification: boolean;
  isFeedbackVisible: boolean;
  isFeedbackPromptVisible: boolean;
  feedbackToastVisible: boolean;
  entity: string;
  task: string;
  chatId: string;
  triggerScrollToBottom: boolean;
  shouldCloseAutomatically: boolean;
}

const initialState: AskLioState = {
  isChatPanelVisible: false,
  responseOnProcess: false,
  hasNotification: false,
  askLioQuery: [],
  suggestedQuetions: [],
  isFeedbackVisible: false,
  isFeedbackPromptVisible: false,
  feedbackToastVisible: false,
  entity: '',
  task: '',
  chatId: '00000000-0000-0000-0000-000000000000',
  triggerScrollToBottom: false,
  shouldCloseAutomatically: true,
};

const askLioSlice = createSlice({
  name: 'askLioSlice',
  initialState,
  reducers: {
    setIsChatPanelVisible(state, action: PayloadAction<boolean>) {
      state.isChatPanelVisible = action.payload;
    },
    addAskLioQuery(
      state,
      action: PayloadAction<{
        query: string;
      }>
    ) {
      const newQuery: AskLioQuery = {
        query: action.payload.query,
        content: '',
        isLoading: true,
      };
      state.askLioQuery.push(newQuery);
    },
    updateAskLioQuery(state, action: PayloadAction<AskLioQuery>) {
      const index = state.askLioQuery.length - 1;

      if (index !== -1) {
        state.askLioQuery[index] = action.payload;
      }
    },
    setResponseOnProcess(state, action: PayloadAction<boolean>) {
      state.responseOnProcess = action.payload;
    },
    setHasNotification(state, action: PayloadAction<boolean>) {
      state.hasNotification = state.isChatPanelVisible ? false : action.payload;
    },
    setFeedbackVisibility(state, action: PayloadAction<boolean>) {
      state.isFeedbackVisible = action.payload;
    },
    setFeedbackPromptVisibility(state, action: PayloadAction<boolean>) {
      state.isFeedbackPromptVisible = action.payload;
    },
    setFeedbackToastVisibility(state, action: PayloadAction<boolean>) {
      state.feedbackToastVisible = action.payload;
    },
    setShouldCloseAutomatically(state, action: PayloadAction<boolean>) {
      state.shouldCloseAutomatically = action.payload;
    },

    // clear state
    clearAskLioState(state) {
      state.isChatPanelVisible = initialState.isChatPanelVisible;
      state.responseOnProcess = initialState.responseOnProcess;
      state.hasNotification = initialState.hasNotification;
      state.askLioQuery = initialState.askLioQuery;
      state.isFeedbackVisible = initialState.isFeedbackVisible;
      state.isFeedbackPromptVisible = initialState.isFeedbackPromptVisible;
      state.feedbackToastVisible = initialState.feedbackToastVisible;
      state.chatId = initialState.chatId;
      state.shouldCloseAutomatically = initialState.shouldCloseAutomatically;
    },
    setEntityAndtask(
      state,
      action: PayloadAction<{
        entity: string;
        task: string;
      }>
    ) {
      state.entity = action.payload.entity;
      state.task = action.payload.task;
    },
    updateSuggesteduestions(
      state,
      action: PayloadAction<AskLioRecommnededQuestion[]>
    ) {
      state.suggestedQuetions = action.payload;
    },
    setChatId(state, action: PayloadAction<string>) {
      state.chatId = action.payload;
    },
    setTriggerScrollToBottom(state, action: PayloadAction<boolean>) {
      state.triggerScrollToBottom = action.payload;
    },
  },
});

export const {
  setIsChatPanelVisible,
  addAskLioQuery,
  updateAskLioQuery,
  setResponseOnProcess,
  setHasNotification,
  setFeedbackVisibility,
  setFeedbackPromptVisibility,
  setFeedbackToastVisibility,
  clearAskLioState,
  setEntityAndtask,
  updateSuggesteduestions,
  setChatId,
  setTriggerScrollToBottom,
  setShouldCloseAutomatically,
} = askLioSlice.actions;

export default askLioSlice.reducer;
